export class LoginModel {
    nombrelogin: string;
    pass: string;
}